module.exports = require("@swa-ui/core/src/Flyout/Flyout.module.scss");